module.exports = __webpack_public_path__ + "static/media/oi-logo.fca93d5a.png";